module.exports = __webpack_public_path__ + "img/640_yz.9bfc22bd.png";